import * as React from "react";
import rehypeReact from "rehype-react";
import { LandingTitle } from "../components/landingTitle";
import { Video } from "../components/video";
import { ShowStream } from "../components/streams";

const Wrapper = ({ children }) => (
  <div className="content py-10">{children}</div>
);

const renderSection = (props) => {
  if (
    props.tagName === "section" ||
    (props.properties &&
      props.properties.className &&
      props.properties.className.includes("section"))
  ) {
    props.tagName = "section";
    props.properties.className = [
      ...(props.properties.className || []),
      "helpthis",
    ];
    return <section {...props} />;
  }
  return null;
};

const components = (metadata) => ({
  video: (props) => <Video {...props} metadata={metadata} />,
  showstream: (props) => <ShowStream {...props} metadata={metadata} />,
  element: renderSection,
  "*": null,
});

export const TemplateClient = (props) => {
  const { post } = props;
  const { frontmatter: info } = post;
  const metadata = {};
  const renderer = new rehypeReact({
    createElement: React.createElement,
    components: components(metadata),
    Fragment: Wrapper,
  }).Compiler;
  return (
    <article className="client alternate-sections">
      <LandingTitle
        title={info.title}
        subtitle={info.subtitle}
        image={info.image}
        contentClass="flex flex-col"
        headingClass="mt-auto w-full !pb-0"
        style={{
          minHeight: "48vh",
        }}
      />
      {/* <HeroSection
            parentClass="mt-20 text-white"
            image={props.data.image}
            gradientClass="bg-gradient-to-r from-rose-700/75 to-purple-900/75"
            >
              <div className="py-10">
                <LandingTitle title={props.data.title}/>
              </div>
            </HeroSection> */}
      {renderer(post.htmlAst)}
    </article>
  );
};
